<template>
  <div class="pt-5 pl-3 pr-3">
    <div class="summary">
      <v-app>
        <h3 class="tNormal">سفارشات</h3>
        <div class="search-section">
          <custom-input
            kind="text"
            container="mini-title ml-5 mt-5"
            classes="mini-title mr-2"
            v-bind:theModel.sync="userMobile"
            label="جستجوی کاربر"
            placeholder="شماره موبایل"
          ></custom-input>
          <button class="purple-btn" @click="searchUserOrders">جستجو</button>
        </div>
        <div
          v-if="theUser != null"
          class="user-details pt-2 d-flex justify-content-start"
        >
          <p class="mini-title tNormal ml-2">نام کاربر:</p>
          <p class="mini-title">{{ theUser.full_name }}</p>
        </div>
        <table class="mt-2">
          <tr>
            <th class="small-cell">شماره سفارش</th>
            <th class="small-cell">نام فروشگاه</th>
            <th>آدرس</th>
            <th class="small-cell">شماره تلفن</th>
            <th class="small-cell">تاریخ پرداخت</th>
            <th class="small-cell">هزینه ارسال</th>
            <th class="small-cell">قابل پرداخت</th>
            <th class="small-cell">کد تخفیف</th>
            <th class="small-cell">وضعیت</th>
            <th class="small-cell">توضیحات</th>
            <th class="small-cell">گزینه ها</th>
            <th>مشاهده</th>
          </tr>
          <an-order
            @reviseOrder="reviseOrder"
            @submit_description="submit_description"
            @see_order="see_order"
            :theOrder="order"
            v-for="(order, i) in orders"
            :key="i"
          >
          </an-order>

          <!-- ??????? Modal ???????? -->
        </table>
        <div v-if="current_page" class="text-center py-2">
          <button
            v-if="current_page !== orders.last_page"
            class="page-keys"
            @click="last(last_page)"
          >
            {{ last_page }}
          </button>
          <span v-if="current_page !== all_data.last_page">...</span>
          <button
            v-if="current_page !== all_data.last_page"
            class="page-keys"
            @click="next()"
          >
            بعدی
          </button>
          <button
            v-if="current_page !== all_data.last_page"
            class="page-keys"
            @click="one_more(current_page + 1)"
          >
            {{ current_page + 1 }}
          </button>
          <button class="page-keys active">{{ current_page }}</button>
          <button
            v-if="current_page - 1"
            class="page-keys"
            @click="one_less(current_page - 1)"
          >
            {{ current_page - 1 }}
          </button>
          <button v-if="current_page - 1" class="page-keys" @click="preview(current_page - 1)">
            قبلی
          </button>
        </div>
        <div class="text-center py-1">
          <button class="go-to-btn" @click="go_to()">برو صفحه</button>
          <div class="d-inline-block">
            <input class="go-to-input" v-model="go_page" type="text" />
          </div>
        </div>

        <v-dialog v-model="dialog" width="800px">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              Open Dialog
            </v-btn>
          </template> -->
          <v-card>
            <div>
              <Order :my_order="detail_product" />
            </div>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import AnOrder from "./partials/OrderSummary";
import Order from "./partials/Order.vue";
import Service from "../../../utils/admin-service";
import CustomInput from "../../Common/CustomInput";
import AddressModal from "../../Common/AddressModal";

export default {
  components: {
    AnOrder,
    Order,
    CustomInput,
    AddressModal,
  },
  setup() {
    const orders = ref(null);
    const go_page = ref();
    const last_page = ref("");
    const all_data = ref();
    const detail_product = ref({});
    const dialog = ref(false);
    const userMobile = ref({ value: null, valid: true });
    const theUser = ref(null);
    const current_page = ref("");
    const theService = computed(() => {
      return Service(false);
    });

    onMounted(() => {
      getAllOrders();
    });

    const getAllOrders = () => {
      theService.value.receive(
        "admin/order",
        {},
        (s, d) => {
          if (s == 200) {
            orders.value = d.data;
            current_page.value = d.data.current_page;
            all_data.value = d.data;
          }
        },
        (s, e) => {}
      );
    };

    const searchUserOrders = () => {
      theService.value.receive(
        "admin/user/search?mobile=" + userMobile.value.value,
        {},
        (s, d) => {
          if (s == 200) {
            if (d.data != []) {
              getUserOrders(d.data.id);
              theUser.value = d.data;
            }
          }
        },
        (s, e) => {}
      );
    };

    const getUserOrders = (id) => {
      theService.value.receive("admin/user/" + id + "/order", {}, (s, d) => {
        if (s == 200) {
          orders.value = d.data;
        }
      });
    };

    const reviseOrder = (order) => {
      let f = new FormData();
      f.append("status", order.status);
      theService.value.transmit(
        "admin/order/" + order.id,
        f,
        (s, d) => {
          alert("تغییر وضعیت انجام شد");
        },
        (s, e) => {}
      );
    };
    const submit_description = (order) => {
      let formData = new FormData();
      formData.append("comment", order.admin_comment);
      theService.value.transmit(
        "admin/desc/order/" + order.id,
        formData,
        (s, d) => {
          alert("توضیحات اضافه شد");
        },
        (s, e) => {}
      );
    };
    const see_order = (order) => {
      ////////// //
      theService.value.receive(
        "admin/order/" + order.id,
        {},
        (s, d) => {
          if (s == 200) {
            detail_product.value = d.data;
            console.log("VALUE TO SEND COMPONENT");
            console.log(detail_product.value);
            // if (detail_product.value.delivery_day != "") {
            //   authService.value.receive(
            //     "admin/preorder/time",
            //     {},
            //     (s, d) => {
            //       times.value = d.data;
            //       items.value.delivery_day = jalalim(items.value.delivery_day)
            //         .locale("fa")
            //         .format("YY-MM-DD");
            //       times.value.map((t) => {
            //         if (t.id == parseInt(items.value.delivery_time)) {
            //           items.value.delivery_time =
            //             " از ساعت " + t.from + " تا " + t.to;
            //         }
            //       });
            //     },
            //     errorHandler
            //   );
            // }
          }
        },
        (s, e) => {}
      );
      //    ///////
      dialog.value = order.id;
      console.log("clicked");
    };
    const next = function () {
      theService.value.receive(
        "admin/order?page=" + (current_page.value + 1),
        {},
        (s, d) => {
          orders.value = d.data;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
        },
        (s, e) => {}
      );
    };
    const preview = function (prev) {
        theService.value.receive(
          "admin/order?page=" + (prev),
          {},
          (s, d) => {
            orders.value = d.data;
            current_page.value = d.data.current_page;
            last_page.value = d.data.last_page;
          },
          (s, e) => {}
        );
      
    };
    const one_more = function () {
      theService.value.receive(
        "/admin/order?page=" + (current_page.value + 1),
        {},
        (s, d) => {
          orders.value = d.data;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
        },
        (s, e) => {}
      );
    };
    const one_less = function () {
      theService.value.receive(
        "/admin/order?page=" +  + (current_page.value - 1),
        {},
        (s, d) => {        
          orders.value = d.data;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
        },
        (s, e) => {}
      );
    };
    const last = function (last_page) {
      theService.value.receive(
        "/admin/order?page=" + last_page,
        {},
        (s, d) => {
          orders.value = d.data;
          current_page.value = d.data.current_page;
        },
        (s, e) => {}
      );
    };
    const go_to = function () {
      theService.value.receive(
        "https://api.golpino.com/api/admin/order?page=" + go_page.value,
        {},
        (s, d) => {

          orders.value = d.data;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
        },
        (s, e) => {}
      );
    };

    return {
      dialog,
      orders,
      userMobile,
      reviseOrder,
      searchUserOrders,
      theUser,
      submit_description,
      see_order,
      detail_product,
      current_page,
      go_page,
      last_page,
      one_more,
      one_less,
      last,
      go_to,
      preview,
      next,
      all_data
    };
  },
};
</script>
<style lang="scss" scoped>
.summary {
  background-color: #fff;
  font-size: 0.9rem;
  font-weight: lighter;
  min-height: 50vh;
  overflow: auto;
  /* width: 100vw; */
}

.search-section {
  border-bottom: 1px solid rgba(127, 127, 127, 0.2);
  padding-bottom: 0.5rem;
}

table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  table-layout: auto;
  text-align: center;
}

td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding-right: 1rem;
}

tr {
  width: 100%;
}

.big-cell {
  width: 75%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.small-cell {
  width: 5%;
  padding: 0 2px;
}
td .shownInput {
  width: 100% !important;
}
.page-keys {
  outline: none;
  padding: 15px;
  margin: 0 3px;
  display: inline-block;
  border-radius: 10px;
  border: solid 1px rgb(204, 204, 204);
  color: gray;
  &.active {
    background: rgb(89, 171, 238);
    color: white;
  }
}
.go-to-btn {
  margin: 0 10px;
  border-radius: 5px;
  padding: 7px;
  font-size: 13px;
  color: white;
  background: #59abee;
  outline: none;
}
.go-to-input {
  border: solid 1px #f0f0f0;
  border-radius: 5px;
  width: 45px;
  outline: none;
  min-height: 35px;
  padding: 5px 0;
  text-align: left;
  color: gray;
  text-align: center;
}
</style>